import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useGroupByEnvironment } from '../discovery/group';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useGroup = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useGroupByEnvironment({
    environmentId: validEnvironmentId,
    userId,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'group',
  });

  const groupQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.groups.edges?.[0];
    return {
      fetching,
      error,
      data: { definition: definitionEdge?.node },
    };
  }, [fetching, error, data]);

  return groupQuery;
};
